export default __webpack_public_path__ + "static/level-up-43e75e3d6c42b892229bdb079fd7a44f.png";